export default {
  baseStyle: {
    fontSize: 14,
    marginTop: 4,
    marginBottom: 1,
    color: 'grey.500',
  },
};
